export default class EmailTemplateContent {

	static replaceColorInString(text: string, color: string | null) {
		return text.replace(/(#0262ab)/g, color ? color : "#0262ab");
	}
}
